<template>
  <div class="h5-group-info-page">
    <div class="cont-wrap">
      <!-- 标题 -->
      <div class="header" v-if="false">
        <span class="title">拼团-{{ courseInfo.course_name }}</span>
        <span class="header-back" @click="back"></span>
      </div>
      <div class="group-cont-wrap">
        <!-- 拼团信息 -->
        <div class="active-info">
          <!-- 结果 -->
          <div class="result">{{ groupResultLabel }}</div>
          <!-- 拼团步骤 -->
          <p class="step">
            <span>下单支付</span>
            <span class="separate"></span>
            <span>邀好友拼团</span>
            <span class="separate"></span>
            <span>人满成团</span>
          </p>
          <!-- 团状态描述 -->
          <div class="active-info-message" v-html="userListMessage"></div>
          <!-- 成员列表 -->
          <div class="active-info-user-list" ref="userList">
            <div
              class="user-list"
              :class="{ 'more-user-list': userLength > 5 }"
            >
              <div
                class="user-item"
                :class="{ 'user-item-leader': item.is_leader === 1 }"
                v-for="(item, index) in activeInfo.member_list || {}"
                :key="index"
              >
                <div class="avater"><img :src="item.avatar" alt="" /></div>
                <div class="name">{{ item.nickname.slice(0, 1) }}***</div>
                <div class="leader-tag" v-if="index === 0">团长</div>
                <div class="refund-tag" v-if="[1, 4].includes(item.state)">
                  {{ item.state === 4 ? "已退款" : "待支付" }}
                </div>
              </div>
              <div
                class="join-box"
                v-for="(item, index) in new Array(couldJoinNum).fill(0)"
                :key="index + (activeInfo.member_list?.length || 0)"
              >
                <span>待邀请</span>
              </div>
            </div>
          </div>
        </div>
        <!-- 课程卡片 -->
        <H5CourseCard :courseInfo="courseInfo" :activeInfo="activeInfo" />
        <!-- 底部按钮 -->
        <div class="footer">
          <div
            class="btn apply-btn"
            v-if="
              activeInfo.state === NO_GROUP &&
              myOrderInfo &&
              myOrderInfo.state !== 4
            "
            @click="shareGroup"
          >
            邀请好友拼团
            <!-- 倒计时 -->
            <div class="count-down" v-if="activeInfo.state === NO_GROUP">
              仅剩 <span>{{ countdown.hours }}</span> :
              <span>{{ countdown.minutes }}</span> :
              <span>{{ countdown.seconds }}</span> 结束
            </div>
          </div>
          <div
            class="btn more-btn"
            v-if="
              activeInfo.state === GROUP_SUCCESS ||
              activeInfo.state === GROUP_FAIL ||
              (activeInfo.state === NO_GROUP && myOrderInfo.state === 4)
            "
            @click="handleViewMore"
          >
            更多优惠课程
          </div>
          <div
            class="btn view-btn"
            v-if="
              activeInfo.state === GROUP_FAIL ||
              (activeInfo.state === NO_GROUP && myOrderInfo.state === 4)
            "
            @click="handleViewCourse"
          >
            查看课程
          </div>
        </div>
      </div>
    </div>
    <!-- 分享弹窗 -->
    <ShareDrawer ref="shareGroupDrawer" />
  </div>
</template>

<script>
import info from "./info.js";
export default {
  mixins: [info],
  methods: {
    shareGroup() {
      const shareContent = `点击链接，一起 ${
        this.activeInfo.group_price / 100
      } 元拼团购买原价 ${this.courseInfo.goods?.price / 100} 元的课程《${
        this.courseInfo.course_name
      }》吧！`;
      const shareUrl = `${process.env.VUE_APP_SAAS_WEB_URL}/group-share/${this.activeId}`;
      if (this.isHXApp) {
        this.handleApply();
      } else if (this.isH5 && !this.isWeChat && !this.isQQ) {
        this.$refs.shareGroupDrawer.openDrawer({
          shareUrl, // 分享地址
          title: shareContent, // 分享标题
          pic: this.courseInfo.cover_url,
          linkShowTitle: true,
          canJoinNum: this.couldJoinNum,
          copyTostMsg: "链接已复制，可以发给好友啦",
        });
      } else {
        this.handleApply();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.h5-group-info-page {
  --group-info-page-bg: #fff7f7;
  --group-info-card-bg: #ffffff;
  --group-info-surface-bg: #fff8f8;
  --group-info-primary: #222426;
  --group-info-secondary: #858687;

  html.dark & {
    --group-info-page-bg: var(--mg-bg-page);
    --group-info-card-bg: var(--mg-bg-card);
    --group-info-surface-bg: var(--mg-bg-elevated);
    --group-info-primary: var(--mg-text-primary);
    --group-info-secondary: var(--mg-text-secondary);
  }

  background: var(--group-info-page-bg);
  .cont-wrap {
    padding-top: 0.24rem;
    min-height: 100vh;
    background: url("../../../assets/images/group-activity/group-bg.png");
    background-size: 100% 11.24rem;
    background-repeat: no-repeat;
  }
  .header {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    padding: 0 0.5333rem;
    height: 1.24rem;
    display: flex;
    align-items: center;
    justify-content: center;
    // box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.07);
    .header-back {
      position: absolute;
      top: 50%;
      left: 0.44rem;
      transform: translateY(-50%);
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-position: center center;
      background-image: url("../../../assets/images/group-activity/h5-back-icon.png");
      cursor: pointer;
      width: 0.64rem;
      height: 0.64rem;
    }
    .title {
      display: inline-block;
      max-width: 80%;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      font-weight: 600;
      font-size: 0.45rem;
      color: #ffffff;
      line-height: 0.64rem;
    }
  }
  .group-cont-wrap {
    position: relative;
    margin: 0 auto;
    width: 9.36rem;
    padding: 0.4rem 0.32rem 0.67rem;
    background: var(--group-info-card-bg);
    border-radius: 0.48rem;
  }
  // 拼团信息
  .active-info {
    .result {
      font-weight: 600;
      font-size: 0.56rem;
      color: var(--group-info-primary);
      line-height: 0.79rem;
      text-align: center;
      margin-bottom: 0.4rem;
    }
    .step {
      margin-bottom: 0.53rem;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 0.93rem;
      background: var(--group-info-surface-bg);
      border-radius: 0.24rem;
      font-weight: 500;
      font-size: 0.32rem;
      color: var(--group-info-primary);
      line-height: 0.44rem;
      .separate {
        width: 0.37rem;
        height: 0.37rem;
        background-image: url("../../../assets/images/product-details/rule-separate.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        margin: 0 0.24rem;
      }
    }
    .active-info-message {
      font-weight: 600;
      font-size: 0.56rem;
      color: var(--group-info-primary);
      line-height: 0.79rem;
      text-align: center;
      margin-bottom: 0.37rem;
    }
  }
  .user-list {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    margin: 0 auto;
    padding-bottom: 0.27rem;
    .join-box {
      width: 1.07rem;
      background-image: url("../../../assets/images/group-activity/add_btn.png");
      background-repeat: no-repeat;
      background-size: 100% auto;
      margin: 0 0.33rem;
      span {
        width: 100%;
        text-align: center;
        display: inline-block;
        font-size: 0.29rem;
        color: var(--group-info-secondary);
        line-height: 0.4rem;
        padding: 1.36rem 0 0.4rem;
      }
    }
  }
  .more-user-list {
    justify-content: start;
  }
  .user-item {
    width: 1.07rem;
    margin: 0 0.33rem;
    position: relative;
    padding-bottom: 0.4rem;
    .avater {
      width: 1.07rem;
      height: 1.07rem;
      border: 0.01rem solid #ffe3ef;
      object-fit: cover;
      border-radius: 50%;
      overflow: hidden;
    }
    .name {
      font-size: 0.29rem;
      color: var(--group-info-primary);
      line-height: 0.4rem;
      margin-top: 0.27rem;
      text-align: center;
    }
    .leader-tag {
      position: absolute;
      top: 0.77rem;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      align-items: center;
      justify-content: center;
      width: 0.99rem;
      height: 0.48rem;
      font-size: 0.32rem;
      color: #ffffff;
      line-height: 0.44rem;
      background: url("../../../assets/images/group-activity/leader-tag-bg.png");
      background-size: 100% 100%;
      z-index: 1;
    }
    .refund-tag {
      position: absolute;
      left: 0;
      top: 0;
      width: 1.07rem;
      height: 1.07rem;
      background: rgba(0, 0, 0, 0.5);
      border: 0.01rem solid #ffe3ef;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 0.29rem;
      color: #ffffff;
      line-height: 0.4rem;
      border-radius: 50%;
    }
  }
  .footer {
    padding-top: 0.93rem;
    display: flex;
    justify-content: center;
  }
  .more-btn {
    width: 4rem;
    height: 1.28rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 0.43rem;
    color: #f03349;
    line-height: 0.43rem;
    background: url("../../../assets/images/group-activity/more-btn-bg.png");
    background-size: 100% 100%;
  }
  .apply-btn {
    position: relative;
    width: 8.71rem;
    height: 1.28rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 0.43rem;
    color: #ffffff;
    line-height: 0.43rem;
    background: url("../../../assets/images/group-activity/apply-btn-bg.png");
    background-size: 100% 100%;
    .count-down {
      position: absolute;
      top: -0.63rem;
      left: 50%;
      transform: translateX(-50%);
      font-weight: 500;
      font-size: 0.29rem;
      color: #222426;
      line-height: 1;
      width: 3.2rem;
      height: 0.43rem;
      background: #fde026;
      border-radius: 1.33rem;
      display: flex;
      align-items: center;
      justify-content: center;
      &::after {
        position: absolute;
        content: "";
        left: 50%;
        transform: translateX(-50%);
        bottom: -0.05rem;
        width: 0.16rem;
        height: 0.05rem;
        background: url("../../../assets/images/group-activity/count-down-after.png");
        background-size: 100% 100%;
      }
    }
  }
  .view-btn {
    width: 4rem;
    height: 1.28rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 0.43rem;
    color: #ffffff;
    line-height: 0.43rem;
    background: url("../../../assets/images/group-activity/view-btn-bg.png");
    background-size: 100% 100%;
    margin-left: 0.67rem;
  }
}
</style>
